module.exports = {
    // index: My BobTV
    "Create my room": "Créer ma salle",
    "Edit my room": "Éditer ma salle",
    "Open my room": "Ouvrir ma salle",
    "Room name": "Nom de la salle",
    "Opened": "Ouvrir",
    "Closed": "Fermer",
    "Delete": "Supprimer",
    "Save": "Sauvegarder",

    "My room is blocked permanently by Bob": "Ma salle est bloquée définitivement par Bob.",
    "Reason:": "Raison :",

    'You are responsible for the content of your room. Please respect the BobTV Terms and Conditions by monitoring text, photo and video materials.': 'Vous êtes responsable du contenu de votre salle. Veuillez faire respecter les CGU de BobTV en surveillant les écrits, les photos et les vidéos diffusés.',
    'Collective moderation is functional on your room but as a creator you can disconnect a user with a single exclusion request.': 'La modération collective est fonctionnelle sur votre salle mais en tant que créateur vous pouvez déconnecter un utilisateur sur une seule demande d\'exclusion.',
    'Users you have blocked can not enter your room.': 'Les utilisateurs que vous avez bloqué ne peuvent pas se connecter sur votre salle.',
    'When you leave the room you are free to close it or not. It will close automatically when it is empty.': 'Lorsque vous quittez la salle vous êtes libre de la fermer ou non. Elle se fermera automatiquement lorsqu\'elle sera vide.',
    
    'Are you sure you want to delete your room?': 'Voulez-vous vraiment supprimer votre salle?',

    'Edit your room': 'Éditer',
    'Slide to close': 'Glisser pour fermer',
    'Slide to open': 'Glisser pour ouvrir',

    "Deactivate room": "Désactiver la salle",
    "Activate room": "Activer la salle",

    "Show in progress": "Show en cours",
    'MY | SHOW price, tokens per minute': 'Nombre de jetons collectés par minute auprès de chaque utilisateur',
    'Activate MY | SHOW':  'Activer MY | Show',
    'Activate the My Show function if you want to automatically receive tokens from logged in users. Select the number of tokens you want to receive per minute from each user.': 'Activez la fonction My Show si vous souhaitez recevoir automatiquement des jetons de la part des utilisateurs connectés. Sélectionnez le nombre de jetons que vous souhaitez recevoir chaque minute de la part de chaque utilisateur.',
    'Connection to the Show of': 'Connexion sur le Show de'
};


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/mybobtv.js